import { Layout } from 'antd';
import React from 'react';
import { HashRouter } from "react-router-dom";
import { LeftMenu } from './LeftMenu';
import { AnimatedRoutes } from "./routes/AnimatedRoutes";

const { Content } = Layout;

const App: React.FC = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <LeftMenu />
      <Layout className="site-layout">
        <Content>
          <HashRouter>
            <AnimatedRoutes />
          </HashRouter>
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;


